import React from "react";
import { usePatientDocumentCreateMutation } from "../../../../../api/patientDocuments/usePatientDocumentCreateMutation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { history } from "../../../../../history";
import { getPathParams } from "../utilities";
import { extractApiError } from "../../../../../utilities/api";
import { CLIENTS_ROUTES } from "../../../../../consts/routes";
import { MESSAGES } from "../config";

export var withDocumentCreate = (Component) => (props) => {
  var { patientId } = getPathParams();

  var { mutateAsync, isLoading } = usePatientDocumentCreateMutation({
    onSuccess: () => {
      uiNotification.success("Document created successfully");
      history.push(CLIENTS_ROUTES.newDocuments(patientId));
    },
    onError: (res) => {
      var message = extractApiError(res);
      uiNotification.error(
        MESSAGES[message] ||
          "Unable to create document. Please try again later.",
      );
    },
  });

  var initiate = async (documents) => {
    if (
      documents.some((x) => {
        return !x.name || !x.filename || !x.doc_type;
      })
    ) {
      return uiNotification.error("Please fill all required fields");
    }

    await mutateAsync({
      patientId,
      documents,
    });
  };

  return (
    <Component
      {...props}
      createDocument={{
        initiate,
        isLoading,
      }}
    />
  );
};
